import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, ArrowLeft } from 'lucide-angular';
import { GradingBadgeComponent } from '../grading-badge/grading-badge.component';
import { AuthService } from '../../../../../common/auth/auth.service';

@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, GradingBadgeComponent],
  templateUrl: './chat-header.component.html',
  styleUrl: './chat-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatHeaderComponent {
  private readonly authService = inject(AuthService);

  readonly backClicked = output<void>();

  protected readonly isAuthenticated$ = this.authService.isAuthenticated();

  protected readonly icons = {
    ArrowLeft,
  };

  protected onBackClick(): void {
    this.backClicked.emit();
  }
}
